import { getWeekMenuSuccess } from "@modules/weekmenu/store/actions/weekmenuActionCreators"
import { StaleWhileRevalidateApiUrls } from "./constants"

export const StaleWhileRevalidateStateServiceWorkerConfig = [
    {
        apiUrl: StaleWhileRevalidateApiUrls.WeeklyRecipesApi,
        action: (data: any) => getWeekMenuSuccess(data),
    },
]
